import { ServiceClient } from 'src/utils'
import type { MensagemDaConversa, Parceiro, Recado } from './MensagemDireta.scopes'

const serviceClient = ServiceClient.singleton()

const BASE_URL = '/api/mensagens-diretas'

export class MensagemDiretaService {
    static #INSTANCE = new MensagemDiretaService()
    static readonly singleton = () => MensagemDiretaService.#INSTANCE

    async listar(busca: string, offset: number, limit: number): Promise<{ total: number; itens: Recado[] }> {
        const params = new URLSearchParams({ offset: `${offset}`, limit: `${limit}` })
        if (busca) params.set('busca', busca)
        return serviceClient.authGet(`${BASE_URL}?${params.toString()}`)
    }

    async buscarParceiros(q: string): Promise<Parceiro[]> {
        return serviceClient.authGet<Parceiro[]>(`${BASE_URL}/parceiros?${new URLSearchParams({ q }).toString()}`)
    }

    async parceiro(ownerId: string): Promise<Parceiro> {
        return serviceClient.authGet<Parceiro>(`${BASE_URL}/parceiros/${encodeURIComponent(ownerId)}`)
    }

    async enviar(ownerId: string, texto: string): Promise<Recado> {
        return serviceClient.authPost<Recado>(BASE_URL, { ownerId, texto })
    }

    async cancelar(id: string): Promise<Recado> {
        return serviceClient.authPost<Recado>(`${BASE_URL}/${encodeURIComponent(id)}/cancelar`, {})
    }

    /** As últimas mensagens do parceiro com a LIA, pela leitura do histórico que já existe. */
    async conversa(ownerId: string, limit = 30): Promise<MensagemDaConversa[]> {
        return serviceClient.authGet<MensagemDaConversa[]>(
            `/api/chat/contacts/${encodeURIComponent(ownerId)}/messages?limit=${limit}`
        )
    }
}

export default MensagemDiretaService.singleton()
